import React from 'react';
import moment from 'moment';
import { Button } from 'semantic-ui-react';
import { COMPLEX_PAUSE_ID, COMPLEX_ACTIVE_ID } from '../../../../constants/appConstants';
import ConfirmPopup from '../../../Common/ConfirmPopup';

const ChangeStatusPauseButton = ({
  complex,
  changeComplexPauseStatus,
  setIsDayOnPauseTomorrow,
  setIsPauseTakeOffTomorrow,
}) => {
  const [isConfirmPopupShow, setIsConfirmPopupShow] = React.useState(false);

  React.useEffect(() => {
    if (complex && complex.paused_at && complex.status !== COMPLEX_PAUSE_ID) {
      const currentDate = moment().format('YYYY-MM-DD').split('-');
      const startPauseDate = complex.paused_at.split('-');
      const formatedCurrentDate = moment(currentDate);
      const formatedStartPauseDate = moment(startPauseDate);
      const isDayOnPause = formatedStartPauseDate.diff(formatedCurrentDate, 'days');
      if (isDayOnPause > 0) setIsDayOnPauseTomorrow(true);
    }
    if (complex && complex.finished_at && complex.status === COMPLEX_PAUSE_ID) {
      const currentDate = moment().format('YYYY-MM-DD').split('-');
      const startPauseDate = complex.finished_at.split('-');
      const formatedCurrentDate = moment(currentDate);
      const formatedStartPauseDate = moment(startPauseDate);
      const isDayOnPause = formatedStartPauseDate.diff(formatedCurrentDate, 'days');
      if (isDayOnPause > 0) setIsPauseTakeOffTomorrow(true);
    }
  }, [complex]);

  return (
    <React.Fragment>
      <Button onClick={() => setIsConfirmPopupShow(true)} color="yellow">
        {complex.status === COMPLEX_PAUSE_ID ? 'Снять с паузы' : 'Поставить на паузу'}
      </Button>
      <ConfirmPopup
        title={`Вы действительно хотите ${
          complex.status === COMPLEX_PAUSE_ID ? 'снять' : 'поставить'
        } курс на паузу?`}
        isShow={isConfirmPopupShow}
        onClose={() => setIsConfirmPopupShow(false)}
        onApply={
          complex.status === COMPLEX_PAUSE_ID
            ? () => changeComplexPauseStatus(complex.id, COMPLEX_ACTIVE_ID)
            : () => changeComplexPauseStatus(complex.id, COMPLEX_PAUSE_ID)
        }
      />
    </React.Fragment>
  );
};

export default ChangeStatusPauseButton;



// WEBPACK FOOTER //
// ./src/Components/Menus/ControlUsers/ChangeStatusPauseButton/index.jsx